import React, { Component } from 'react';

class BufImageGrey32 extends Component {
    
    constructor(props) 
    {
        super(props)

        this.state = {
            data: props.data,
        }
    }
    
    componentWillMount () {

        var data = new Uint8Array(this.state.data);
        var dataView = new DataView(data.buffer);

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        canvas.width = dataView.getUint32(0, false); // dx
        canvas.height = dataView.getUint32(4, false); // dy

        var currImageData = context.createImageData(canvas.width, canvas.height);

        let size = canvas.width * canvas.height

        for (var i = 0; i < size; i++)
        {
            var data_index = 8 + i * 4;
            var r = dataView.getUint32(data_index, false) / 255

            var image_index = i * 4;
            currImageData.data[image_index] = r
            currImageData.data[image_index+1] = r
            currImageData.data[image_index+2] = r
            currImageData.data[image_index+3] = 255
        }

        context.putImageData(currImageData, 0, 0);
    
        const dataURI = canvas.toDataURL()

        this.setState({dataURI})
      }
    
      render() {
        return <img src={this.state.dataURI} alt="" />
      }
}

export default BufImageGrey32;